import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d8909946")

_pushScopeId("data-v-d8909946")
const _hoisted_1 = { class: "ltlorder" }
const _hoisted_2 = {
  key: 0,
  class: "ltlorder__loading"
}
const _hoisted_3 = { class: "ltlorder__body" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_loader = _resolveComponent("s-loader")!
  const _component_ltl_order_header = _resolveComponent("ltl-order-header")!
  const _component_s_pagination = _resolveComponent("s-pagination")!
  const _component_invoices_list = _resolveComponent("invoices-list")!
  const _component_invoice_document = _resolveComponent("invoice-document")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.LTLOrderState.state.is_loading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_s_loader)
        ]))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_ltl_order_header, {
            orderId: _ctx.$route.params.order_id
          }, null, 8, ["orderId"]),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_invoices_list, {
              title: "Накладные по заказу",
              loading: _ctx.LTLOrderState.state.is_loading,
              "loading-excel": _ctx.LTLOrderState.state.is_excel_loading,
              invoices: _ctx.LTLOrderState.data,
              "order-id": _ctx.$route.params.order_id,
              "in-order": "",
              "is-extended": "",
              onRefresh: _ctx.loadLTLOrderHandler,
              onExcel: _ctx.onExportExcel
            }, {
              default: _withId(() => [
                _createVNode(_component_s_pagination, {
                  "total-pages": _ctx.LTLOrderState.pagination.total_pages,
                  value: _ctx.LTLOrderState.pagination.current_page,
                  onChange: _ctx.loadLTLOrderHandler
                }, null, 8, ["total-pages", "value", "onChange"])
              ]),
              _: 1
            }, 8, ["loading", "loading-excel", "invoices", "order-id", "onRefresh", "onExcel"])
          ])
        ], 64)),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.LTLOrderState.data_print, (invoice, i) => {
      return (_openBlock(), _createBlock("div", {
        key: `ltlorder-id-invoice-for-print-${i}`
      }, [
        (_openBlock(), _createBlock(_Fragment, null, _renderList(2, (j) => {
          return _createVNode(_component_invoice_document, {
            key: `ltlorder-id-invoice-for-print-copy-${j}`,
            invoice: invoice,
            class: { 'InvoiceDocument--dotted': !_ctx.isEven(j) },
            style: _ctx.isEven(j) ? 'padding-top: 6px;' : 'padding-bottom: 10px;'
          }, null, 8, ["invoice", "class", "style"])
        }), 64))
      ]))
    }), 128))
  ]))
})